module.exports = __webpack_public_path__ + "static/media/KG.b1628f47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/KG.svg
// module id = 287
// module chunks = 0